import React, { useMemo, useEffect, useState } from 'react';
import { Grid, GridCellProps, GridRowProps, GridNoRecords, GridColumn as Column } from "@progress/kendo-react-grid";
import Styles from "./styles.module.scss"
import ConfirmationModal from '../../modal/confirmation/confirmationModal';
import Button from "../../compopnents/button"; 
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { getTimeSheetDetails , approveTimeSheet ,  rejectTimeSheet } from "./services";
import Acknowledgement from "./acknowledgement";
import Headline6 from "../../compopnents/headings/Headline6"; 
import { Icon } from '@iconify/react';
import { REACT_APP_CANDIDATE_FREELANCER } from '../../utils/common';
import { postAPI } from '../../api';
import mixpanelData from '../../utils/mixpanel';
import { checkTimesheetStatus } from "../../utils/ellowutils";


interface Product {
    workHoursCount: string;
    dayResult: string;
    entryDate: string,
    entryDay: string,
}

interface Props {
  OnSubmit?: any,
  loginId?: string | null,
}

interface CellRenderProps {
    originalProps: GridCellProps;
    td: React.ReactElement<HTMLTableCellElement>;
    enterEdit: (dataItem: Product, field: string | undefined) => void;
    editField: string | undefined;
}
  
interface RowRenderProps {
    originalProps: GridRowProps;
    tr: React.ReactElement<HTMLTableRowElement>;
    exitEdit: () => void;
    editField: string | undefined;
}


const SubmitTimesheet: React.FC<Props> = ({
}) => {

    const [selected, setSelected] = React.useState<number>(0);
    const loginId = localStorage.getItem('loginId') 

    let query: any = window.location.href
    let urlParams: any = new URL(query)
    let timesheetId: any = urlParams.search.slice(13,49)
    let projectId: any = urlParams.search.slice(60,96)
    let type: any = urlParams.searchParams.get("type")
    let managerEmail: any = urlParams.search.slice(123)    

    const [reportingManagerEmail, setReportingManagerEmail] = useState<any>()

  
  useEffect(() => {  

    timeSheetDetails(timesheetId, projectId) 
    
    if(type === 'APRV' || type === 'manager'){
      setButtonDisable(true)
    }  
  },[])

  const timeSheetDetails = (timesheetId: any, projectId: any) => {    
    getTimeSheetDetails(timesheetId,projectId).then((response) => {
      if(response && response.status === 1){
        if(response.data[0].timesheetDetails[0].timesheet_status === '4'){
          setRejectComment(response.data[0].timesheetDetails[0].reject_comment)
          setcandidate_name(response.data[0].timesheetDetails[0].candidate_name)
          setStartDate(response.data[0].timesheetDetails[0].start_date)
          setEndDate(response.data[0].timesheetDetails[0].end_date)
          setAcknowledgement(true)
        }
        if(response.data[0].timesheetDetails[0].timesheet_status === '3'){
          setAcknowledgement(true)
        }
        setData(response.data[0].timesheetEntries) 
        setActualWorkingDays(response.data[0].timesheetDetails[0].actual_working_days)
        setHolyDays(response.data[0].timesheetDetails[0].holidays)
        setLeaves(response.data[0].timesheetDetails[0].leaves)
        setOverTime(response.data[0].timesheetDetails[0].overtime)
        setActualWorkingHours(response.data[0].timesheetDetails[0].actual_working_hours)
        setTotalWorkingDays(response.data[0].timesheetDetails[0].total_working_days)
        setProjectDetails(response.data[0].projectDetails[0])
        setStartDate(response.data[0].timesheetDetails[0].start_date)
        setEndDate(response.data[0].timesheetDetails[0].end_date)
        setcandidateId(response.data[0].candidateDetails[0].candidateId)
        setcandidate_name(response.data[0].timesheetDetails[0].candidate_name)
        setCandidatePhone(response.data[0].candidateDetails[0].phoneNumber)
        setCandidateEmail(response.data[0].candidateDetails[0].email)  
        setReportingManagerEmail(response.data[0].projectDetails[0].reportingManagerEmail) 
      }
      mixpanelData('New MT - Timesheet viewed', {
        // 'Distinct id': localStorage.getItem('loginId'),
        'Candidate email': response && response.data[0].candidateDetails[0].email,
        'Candidate name': response && response.data[0].candidateDetails[0].candidateName,
        'Company name': response && response.data[0].projectDetails[0].companyName,
        'Pay period start date': response && response.data[0].timesheetDetails[0].start_date && new Date(parseInt(response.data[0].timesheetDetails[0].start_date)).toDateString(),
        'Pay period end date': response && response.data[0].timesheetDetails[0].end_date && new Date(parseInt(response.data[0].timesheetDetails[0].end_date)).toDateString(),
        'Status': checkTimesheetStatus(response && response.data[0].timesheetDetails[0].timesheet_status).value,
        'Candidate loginid': response.data[0].candidateDetails[0].candidateId
    })
    })
  }

  const EDIT_FIELD = "inEdit";

    const [tablearray, setTableArray] = useState<Array<Product>>([])
    const [data, setData] = React.useState<Array<Product>>(tablearray);
    const [actualWorkingDays , setActualWorkingDays] = useState<any>()
    const [totalWorkingDays , setTotalWorkingDays] = useState<any>()
    const [actualWorkingHours , setActualWorkingHours] = useState<any>()
    const [HolyDays , setHolyDays] = useState<any>()
    const [leaves , setLeaves] = useState<any>()
    const [overTime , setOverTime] =  useState<any>()
    const [changes, setChanges] = React.useState<boolean>(false);
    const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false)
    const [modal, setModal] = useState<boolean>(false)
    const [buttonDisable, setButtonDisable] = useState<boolean>(false)
    const [acknowledgement , setAcknowledgement] = useState<boolean>(false)
    const [rejectComment , setRejectComment] = useState<any>()
    const [candidate_name, setcandidate_name] = useState<any>()
    const [candidateId, setcandidateId] = useState<any>()
    const [candidatePhone, setCandidatePhone] = useState<any>()
    const [candidateEmail, setCandidateEmail] = useState<any>()
    const [rejectResponse, setRejectResponse] = useState<any>()
    const [startDate , setStartDate ] = useState<any>()
    const [endDate , setEndDate ] = useState<any>()
    const [projectDetails, setProjectDetails] = useState<any>()

    const checkDate = (value: string) => {
        
        switch(value){
            case 'Saturday':
                return 'Weekend'
                break;
            case 'Sunday':
                return 'Weekend'
                break;
            default:
                return ''
        }
    }

    const checkLeaves = (halfday: any, fullday: number) => {      
      return (halfday/2) + fullday
    }

    const calcTotalworkingHours = (data: any) => {
      let hours = 0
       data && data.map((item: any) => {
        hours = hours + Number(item.workHoursCount)
      })
      return hours
    }

  const submitApproveTimeSheet = () => {
    let value = {
      "timesheetId": timesheetId,
      "reportingManagerEmail": managerEmail
  }
  approveTimeSheet(value).then((response) => {
    
    if (response && response.status === 1) {   
      mixpanelData('New MT - Timesheet approved', {
        'Distinct id': reportingManagerEmail,
        'Candidate email': response && response.data.email,
        'Candidate name': response && response.data.candidateName,
        'Position name': response && response.data.position,
        'Company name': response && response.data.companyName,
        'Pay period start date': response && response.data.startDate && new Date(parseInt(response.data.startDate)).toDateString(),
        'Pay period end date': response && response.data.endDate && new Date(parseInt(response.data.endDate)).toDateString(),
        'Verified by': response && response.data.verifiedBy,
        'Candidate loginid': candidateId,
        'Status': 'Approved'
    })
        setAcknowledgement(true)
      }
  }) 
  }

  const submitRejectTimeSheet = (data: any) =>{
    setModal(false)
    let value = {
        "timesheetId": timesheetId,
        "reportingManagerEmail": managerEmail,
        "rejectComment": data.rejectComment
    }  
    setRejectComment(data.rejectComment)
    rejectTimeSheet(value).then((response) => {
      if (response && response.status === 1) {  
        mixpanelData('New MT - Timesheet rejected', {
          'Distinct id': reportingManagerEmail,
          'Candidate email': response && response.data[0].email,
          'Candidate name': response && response.data[0].candidateName,
          'Position name': response && response.data[0].position,
          'Company name': response && response.data[0].companyName,
          'Pay period start date': response && response.data[0].startDate && new Date(parseInt(response.data[0].startDate)).toDateString(),
          'Pay period end date': response && response.data[0].endDate && new Date(parseInt(response.data[0].endDate)).toDateString(),
          'Verified by': response && response.data[0].verifiedBy,
          'Candidate loginid': candidateId,
          'Status': 'Rejected'
      })
          setRejectResponse(response.data[0])
          setcandidate_name(response.data[0].candidate_name)
          setStartDate(response.data[0].startDate)
          setEndDate(response.data[0].endDate)
          setAcknowledgement(true)
        }
    }) 
  }

  const downloadHandle=(url:any, name: string, projectName: string, startDate: number)=>{     
         
    const monthNumber = new Date(startDate).getMonth()
    const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    let presentMonth = months[monthNumber]

    fetch(url).then(response => {
        
      response.blob().then(blob => {
          const fileURL = window.URL.createObjectURL(blob);
          let alink = document.createElement('a');
          alink.href = fileURL;
          alink.download =`${name}-${projectName}-${presentMonth}.pdf`;
          alink.click();
      })
  })
  }
  
  const downloadTimesheet = () => {
    let value = {
      "action": "getObject",
      "filename": `timesheetUploads/${timesheetId}.pdf`,
      "bucketName": "ellow-prod-doc-upload",
    };
    
    postAPI(REACT_APP_CANDIDATE_FREELANCER + '/api/v1/tg/resume-signed-url', value).then((data) => {
      let signedUrl = data.url;
      downloadHandle(signedUrl, candidate_name, projectDetails && projectDetails.projectName, startDate)
    })
  }


  return (
    
    <div>
    { acknowledgement === false &&
    <section className={Styles.dashboardWrapper}>
        <div className={Styles.dashboardContent}>                  
              <div className="contentBox mb-40">
                <div className="innerPadd24">
                <div className={Styles.basicHeadWrap}>
                    <Headline6>Timesheet</Headline6>
                    <div className={Styles.basicDetails}>
                  <div className={Styles.basicHeadWrap}>
                    <Headline6>Basic Info</Headline6>
                    {/* <button className={Styles.downloadButton} onClick={" "}><Icon icon="ic:outline-file-download" /></button> */}
                  </div>
                  <div className={Styles.basicInfoCard}>
                    <div className={Styles.cardItrem}>
                      <div className={Styles.form}>
                        <label>Customer:</label>
                       { projectDetails && projectDetails.companyName}
                      </div>
                      <div className={Styles.form}>
                        <label>Employee Email:</label>
                        {candidateEmail}
                      </div>
                    </div>
                    <div className={Styles.cardItrem}>
                      <div className={Styles.form}>
                        <label>Employee Name:</label>
                        {candidate_name}
                      </div>
                      <div className={Styles.form}>
                        <label>Reporting Manager:</label>
                        {projectDetails && projectDetails.reportingManagerName}
                      </div>
                    </div>
                    <div className={Styles.cardItrem}>
                      <div className={Styles.form}>
                        <label>Employee Phone:</label>
                        {candidatePhone}
                      </div>
                      <div className={Styles.form}>
                        <label>Reporting Manager Email:</label>
                        {projectDetails && projectDetails.reportingManagerEmail}
                      </div>
                    </div>
                    <div className={Styles.cardItrem}>
                      <div className={Styles.form}>
                        <label>Pay Period Start:</label>
                       {new Date(parseInt(startDate)).toDateString()}
                      </div>
                      <div className={Styles.form}>
                        <label>Pay Period End: </label>
                        {new Date(parseInt(endDate)).toDateString()}
                      </div>
                    </div>
                    <div className={Styles.cardItrem}>
                      <div className={Styles.form}>
                        <label>Project:</label>
                        {projectDetails && projectDetails.projectName}
                      </div>
                    </div>
                  </div>
              </div>
                    <button onClick={downloadTimesheet} className={Styles.downloadButton}><Icon icon="ic:outline-file-download" /></button>
                  </div>
                <div className="tableStyle no-padd-top no-min-height">
                  <Grid
                    data={data}
                    rowHeight={50}
                    editField={EDIT_FIELD}
                  >
                    <GridNoRecords>
                      <div className="noData">
                        <Icon icon="mdi:smiley-neutral-outline" />
                        No data to display
                      </div>
                  </GridNoRecords>
                  <Column field="day" title="Day" cell={(props: GridCellProps) => dayCell(props)} editable={false}/>
                  <Column field="date" title="Date" cell={dateCell} editable={false}/>
                  <Column field="workHoursCount" title="No.of working Hours/H" cell={workHourCell}/>
                  <Column field="workDescription" title="Work Description" cell={workDescriptionCell}/>
                  <Column field="status" title="Status" cell={statusCell}/>
                  </Grid>
                </div>
                <div className={Styles.totalInfo}>
                    <div className={Styles.cardItremWrap}>
                      <div className={Styles.cardItrem}>
                          <div className={Styles.form}>
                            <label>Total working days in this month:</label>
                            {totalWorkingDays}
                          </div>
                          <div className={Styles.form}>
                            <label>Actual working days:</label>
                            {actualWorkingDays}
                          </div>
                      </div>
                      <div className={Styles.cardItrem}>
                          <div className={Styles.form}>
                            <label>Holidays</label>
                            {HolyDays}
                          </div>
                          <div className={Styles.form}>
                            <label>Leaves: </label>
                            {leaves}
                          </div>
                      </div>
                      <div className={Styles.cardItrem}>
                          <div className={Styles.form}>
                            <label>Actual working hours:</label>
                            <span className={Styles.total}>{actualWorkingHours}</span>
                          </div>
                          <div className={Styles.form}>
                            <label>Overtime: </label>
                            {overTime}
                          </div>
                      </div>
                    </div>
                    {buttonDisable &&
                    <div className={Styles.totalaction}>
                      <Button  onClick={() => setModal(true)} type="submit" variant="reject">Reject</Button>
                      <Button  onClick={() =>submitApproveTimeSheet()} type="submit" variant="primary">Approve</Button>
                    </div>
                    }
                </div>        
                </div> 
            </div>
            </div>
            {modal && <ConfirmationModal onClose={ () => setModal(false)} submit={submitRejectTimeSheet} reject={true}/>}
    </section>
    }
    { acknowledgement === true &&
      <Acknowledgement rejectComment={rejectComment} response={rejectResponse} candidate_name={candidate_name} startDate={startDate} endDate={endDate}/>
    }
    </div>
  )
}

export default SubmitTimesheet;

const dayCell = (props: GridCellProps) => {
  return (
      <td>
          <div className="userInfo">
              {props.dataItem && props.dataItem.entry_day}
          </div>
  </td>
)
}

const dateCell = (props: GridCellProps) => {
  let date = new Date(parseInt(props.dataItem.entry_date)).toDateString()
    return (
        <td>
            <div className="userInfo">
                {date}
            </div>
    </td>
)
}

const workHourCell = (props: GridCellProps) => {
  let date = new Date(parseInt(props.dataItem.entry_date)).toDateString()
    return (
        <td>
            <div className="userInfo">
                {props.dataItem.workhours_count}
            </div>
    </td>
)
}

const workDescriptionCell = (props: GridCellProps) => {
  let date = new Date(parseInt(props.dataItem.entry_date)).toDateString()
    return (
        <td>
            <div className="userInfo">
                {props.dataItem.work_description}
            </div>
    </td>
)
}

const statusCell = (props: GridCellProps) => {
  let date = new Date(parseInt(props.dataItem.entry_date)).toDateString()
    return (
        <td>
            <div className="userInfo">
                {props.dataItem.day_status}
            </div>
    </td>
)
}


const DropDown = (props: GridCellProps) => {
 
  

  const handleChange = (e: DropDownListChangeEvent) => {
    if(props.onChange){
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value.text,
      });
    }
    
  }

  return (
      <td>
          { props.dataItem.day_status ? <DropDownList
              style={{ width: "100%" }}
              onChange={handleChange}
              value={findDayResult(props.dataItem.day_status)}
              data={[
                  { text: 'Holiday', id: 1 },
                  { text: 'Half day', id: 2 },
                  { text: 'Leave', id: 3 },
                  { text: 'Full day leave', id: 4 },
                  { text: 'Compensation off', id: 5 }
              ]}
              textField="text"
          /> : props.dataItem.day_status}
      </td>
  )
}

const findDayResult = (value: any) => {
  switch(value){
    case 'Holiday':
      return { text: 'Holiday', id: 1 }
    case 'Half day':
      return { text: 'Half day', id: 2 }
    case 'Leave':
      return { text: 'Leave', id: 3 }
    case 'Full day leave':
      return { text: 'Full day leave', id: 4 }
    case 'Compensation off':
      return { text: 'Compensation off', id: 5 }

  }
}
